module.exports = __webpack_public_path__ + "img/Klaim.254e0533.svg";